import React from "react";

/**
 * GenerateContentButton component for navigating to the GenerateContent page.
 */

import { useNavigate } from "react-router-dom";
import PencilIcon from "../common/icons/PencilIcon";

const GenerateContentButton: React.FC<{ className?: string }> = ({
  className = "",
}) => {
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  return (
    <button
      className={`px-6 my-1 text-base font-medium border-none rounded-full outline-none text-primary-content bg-accent btn flex-nowrap whitespace-nowrap ${className}`}
      onClick={() => handleNavigate("/genera-contenuto")}
    >
      <PencilIcon className="w-4" />
      Genera contenuto
    </button>
  );
};

export default GenerateContentButton;
